const sensorLat = [
  { type: 'required', message: 'Sensor Latitude is required' },
  { type: 'pattern', message: 'Sensor Latitude must contain numbers' },
  { type: 'minlength', message: 'Sensor Latitude must have at least 10 digits' },
  { type: 'maxlength', message: 'Sensor Latitude must be at most of 17 digits' }
]

export default {
  sensorLat
}
